module.exports = __webpack_public_path__ + "static/media/bg_minecraft-one.700c65cf.png";